<template>
  <main>
    <AgendaAtivaCompromissoModal
      :loading-options="agendamentosStore?.state?.loadingSelectOptions"
      :tipos-compromissos="agendamentosStore?.state?.tipo_compromisso"
      :motivos-reagendamento="agendamentosStore?.state?.motivos_reagendamento"
      :agendamento-cadastro="agendamento_cadastro"
      :agenda-ativa-store="agendaAtivaStore"
      :save-agendamento="() => saveAgendamento()"
    />

    <AtendimentoImpressaoModal
      :agendamento="agendamentosStore.state?.agendamento"
      visible="atendimento-agenda-ativa-impressao-modal"
    />

    <AgendaTecnicoImpressaoModal
      :tecnico="tecnicoLogado?.nome"
      :data-atendimento="dataFormatadaAgenda"
      :expediente="agendamentosStore.state?.expedienteAgendaAtiva?.horario"
      :unidade="agendamentosStore.state?.expedienteAgendaAtiva?.unidade"
      :agenda="agendamentosStore.state?.agendaAtiva"
      visible="agenda-ativa-tecnico-impressao-modal"
      :get-text-status-style="(it) => getTextStatusStyle(it)"
    />

    <AtendimentoModal
      :atendimento="atendimento"
      :loading-options="agendamentosStore?.state?.loadingSelectOptions"
      :agendamentos-store="agendamentosStore"
      :put-atendimento="() => putAtendimento()"
    />

    <section class="row mt-3">
      <div class="col-12">
        <h4 class="font-weight-bold">
          Escolha a agenda que deseja visualizar
        </h4>
      </div>

      <form-radio
        grid="12"
        name="visualizacaoAgenda"
        v-model="visualizacao_agenda"
        :itens="options_radio"
      />
    </section>

    <section
      class="mt-2 border-top"
      v-if="!visualizacao_agenda"
    >
      <form-select
        :noGrid="true"
        class="pl-0 mt-3 mb-3"
        label="Técnicos da unidade"
        id="tecnicosUnidade"
        name="tecnicosUnidade"
        :loading="agendaAtivaStore.state.loadingTecnicos"
        :itens="agendaAtivaStore.state.tecnicos"
        v-model="agenda.tecnico_id"
        @selected="setTecnico"
      />
    </section>

    <section
      :class="[
        { 'border-top': true },
         'mt-2'
       ]"
    >
      <section class="mt-3 d-flex" style="column-gap: 20px">
        <v-date-picker
          is-required
          locale="pt-BR"
          :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
          v-model="agenda.data_agendamento"
          @input="getDataAgendamento"
        />
        <div class="d-flex flex-column w-100" style="gap: 15px">
          <div class="d-flex flex-column" style="gap: 10px; color: #212529 !important;">
            <div>
              Técnico:
              <span class="font-weight-bolder">
              {{ tecnicoLogado?.nome }} {{ tecnicoLogado?.profissao ? `(${tecnicoLogado?.profissao})` : null }}
            </span>
            </div>
            <div v-if="tecnicoLogado?.unidade?.nome">
              Unidade:
              <span class="font-weight-bolder">
                {{ tecnicoLogado?.unidade?.nome }}
              </span>
            </div>
          </div>

          <div class="d-flex flex-column w-100" style="gap: 15px">
            <load mode="table" text="Aguarde um momento." v-if="agendamentosStore?.state?.loadingAgendaAtiva"/>

            <section v-else>
              <div
                class="alert alert-info alert-dismissible fade show shadow text-dark"
                role="alert"
              >
                <h5 class="mb-0">
                  <b> Obs.</b> Os horários exibidos na agenda correspondem apenas aos compromissos já <b> cadastrados </b>.
                  Para <b> adicionar </b> novos <b> eventos, </b> como <b> férias </b>, <b> afastamentos </b>
                  ou outros <b> compromissos </b>, clique no botão azul <b> "+" </b> localizado na tabela!
                </h5>
                <button
                  type="button"
                  class="close text-danger"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <table
                class="b-table table bg-white b-table-stacked-md table-sm mb-0"
                style="border: 1px solid #0000152C;"
              >
                <tbody>
                  <tr style="background: #f8fafc;">
                    <td colspan="4" style="border: 1px solid #0000152C;">
                      <section class="d-flex align-items-center justify-content-between pt-1 pb-1">
                        <strong>
                          Agenda - {{ dataFormatadaAgenda }}
                          {{ agendamentosStore.state?.expedienteAgendaAtiva?.horario ? `(${agendamentosStore.state?.expedienteAgendaAtiva?.horario})` : null }}
                        </strong>
                        <b-button
                          :title="$t('Adicionar um novo evento/compromisso')"
                          size="xs"
                          class="mb-0"
                          type="button"
                          v-b-tooltip.hover
                          variant="primary"
                          @click="() => adicionarNovoEvento()"
                        >
                          <i class="fas fa-light fa-plus"></i>
                        </b-button>
                      </section>
                    </td>
                  </tr>
                  <template v-if="agendamentosStore.state.agendaAtiva?.periodo">
                    <tr>
                      <td style="border: 1px solid #0000152C; padding-top: 10px; padding-bottom: 10px;">
                        <strong class="d-flex align-items-center flex-wrap" style="column-gap: 5px">
                          <i
                            v-if="agendamentosStore.state.agendaAtiva?.periodo?.icone"
                            :class="`mdi mdi-18px ${agendamentosStore.state.agendaAtiva?.periodo?.icone}`"
                          />
                          {{ agendamentosStore.state.agendaAtiva?.periodo?.descricao }}
                          ({{ agendamentosStore.state.agendaAtiva?.periodo?.dia | formatDate() }}
                          à
                          {{ agendamentosStore.state.agendaAtiva?.periodo?.dia_fim | formatDate() }})
                        </strong>
                      </td>
                      <td
                        style="
                          white-space: nowrap;
                          width: 1%;
                          text-align: right;
                          border-top: 1px solid #0000152C;
                          border-bottom: 1px solid #0000152C;
                          border-right: 1px solid #0000152C;
                          padding: 6px;
                        "
                      >
                        <div class="d-flex align-items-center justify-content-end" style="column-gap: 5px; width: 100%;">
                          <b-button
                            :title="$t('Editar')"
                            class="m-0"
                            size="sm"
                            type="button"
                            v-b-tooltip.hover
                            variant="link"
                            style="color: black"
                            @click="() => getAgendamentoById(agendamentosStore.state.agendaAtiva?.periodo)"
                          >
                            <i class="mdi mdi-pencil mdi-18px"/>
                          </b-button>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-else-if="agendamentosStore.state.agendaAtiva?.agenda?.length > 0">
                    <tr class="font-size-15" v-for="(item, idx) in agendamentosStore.state.agendaAtiva?.agenda" :key="idx">
                      <td
                        style="
                          white-space: nowrap;
                          width: 1%;
                          border: 1px solid #0000152C;
                          padding: 6px
                        "
                      >
                        <strong> {{ item?.horario }} </strong>
                      </td>

                      <td
                        style="
                          border-top: 1px solid #0000152C;
                          border-bottom: 1px solid #0000152C;
                          border-left: 1px solid #0000152C;
                          padding: 6px;
                        "
                      >
                        <div class="d-flex flex-column">
                          <span>
                            <strong v-if="!show_name_agenda[item.id]">
                              {{ item?.atendimento?.usuarios[0]?.nome }}
                              <span v-if="item?.atendimento?.usuarios?.length > 1">
                                 e mais {{ item?.atendimento?.usuarios?.length - 1 }} pessoa(s)
                              </span>
                            </strong>
                            <template v-if="item?.atendimento?.usuarios?.length > 1">
                              <template v-if="!show_name_agenda[item.id]">
                                <a href="#" @click.prevent="toggleNameAgenda(item.id, true)">
                                  Ver mais
                                </a>
                              </template>
                              <template v-else>
                                <span>
                                  <strong> {{ item?.atendimento?.usuarios.map(it => it?.nome).join(', ') }} </strong>
                                  <a href="#" @click.prevent="toggleNameAgenda(item.id, false)">
                                    Ver menos
                                  </a>
                                </span>
                              </template>
                            </template>
                          </span>
                          <strong v-if="item?.atendimento">
                            {{ item?.atendimento?.descricao }}
                          </strong>

                          <strong
                            :style="getTextStatusStyle(item)"
                            v-if="!item.atendimento || (item?.atendimento && item?.status?.value === 'REAGENDADO')"
                          >
                            {{ item?.descricao }}
                          </strong>
                        </div>
                      </td>

                      <td
                        class="font-size-14"
                        style="
                          white-space: nowrap;
                          width: 1%;
                          text-align: right;
                          border-top: 1px solid #0000152C;
                          border-bottom: 1px solid #0000152C;
                          padding: 6px;
                        "
                      >
                        <strong :style="{ color: item?.status?.cor }">
                          {{ item?.status?.value }}
                        </strong>
                      </td>

                      <td
                        style="
                          white-space: nowrap;
                          width: 1%;
                          text-align: right;
                          border-top: 1px solid #0000152C;
                          border-bottom: 1px solid #0000152C;
                          border-right: 1px solid #0000152C;
                          padding: 6px;
                        "
                      >
                      <div class="d-flex align-items-center justify-content-end" style="column-gap: 5px; width: 100%;">
                        <b-button
                            :title="$t('Reagendar')"
                            class="m-0"
                            v-if="item?.agendamento_acoes?.includes('editar_atividade')"
                            size="sm"
                            type="button"
                            v-b-tooltip.hover
                            variant="link"
                            style="color: black"
                            @click="() => getAgendamentoById(item)"
                          >
                            <i class="mdi mdi-calendar-clock mdi-18px"/>
                          </b-button>
                          <b-button
                            :title="$t('Excluir atividade')"
                            v-if="item?.agendamento_acoes?.includes('excluir_atividade')"
                            class="m-0"
                            size="sm"
                            type="button"
                            v-b-tooltip.hover
                            variant="link"
                            style="color: black"
                            @click="() => deleteAgendamento(item)"
                          >
                            <i class="mdi mdi-delete-forever mdi-18px"/>
                          </b-button>
                          <b-dropdown
                            v-if="item?.atendimento"
                            size="lg"
                            no-caret
                            variant="link"
                            v-b-tooltip.hover
                            right
                            title="Ações referente ao atendimento"
                            toggle-class="text-decoration-none"
                            class="flex-grow-1"
                          >
                            <template #button-content>
                              <i class="fas fa-ellipsis-v" style="color: black"/>
                            </template>
                            <b-dropdown-item
                              target="_blank"
                              :to="`/dashboard/familias/edit/${item?.atendimento?.familia_id}`"
                              v-if="item?.atendimento_acoes?.includes('ver_prontuario')"
                            >
                              <div class="d-flex align-items-center" style="column-gap: 5px">
                                <i class="mdi mdi-account-group"></i>
                                Visualizar Prontuário Familiar
                              </div>
                            </b-dropdown-item>
                            <b-dropdown-item target="_blank" :to="`/dashboard/usuario/edit/${item?.atendimento?.responsavel_id}`">
                              <div class="d-flex align-items-center" style="column-gap: 5px">
                                <i class="fas fa-user"></i>
                                Visualizar Prontuário do Usuário
                              </div>
                            </b-dropdown-item>
                            <b-dropdown-item @click="getAtendimento(item)">
                              <div class="d-flex align-items-center" style="column-gap: 5px">
                                <i class="fas fa-pen"></i>
                                Editar
                              </div>
                            </b-dropdown-item>
                            <b-dropdown-item @click="() => impressaoAgendamento(item)">
                              <div class="d-flex align-items-center" style="column-gap: 5px">
                                <i class="fas fa-print"></i>
                                Imprimir Agendamento
                              </div>
                            </b-dropdown-item>
                            <b-dropdown-item>
                              <div class="d-flex align-items-center" style="column-gap: 5px">
                                <i class="fas fa-envelope"></i>
                                Enviar mensagem eletrônica
                              </div>
                            </b-dropdown-item>
                            <b-dropdown-item @click="() => cancelar(item)">
                              <div class="d-flex align-items-center" style="column-gap: 5px">
                                <i class="fas fa-times"></i>
                                Cancelar
                              </div>
                            </b-dropdown-item>
                          </b-dropdown>
                          <b-dropdown
                            v-if="item?.agendamento_acoes?.includes('alterar_status')"
                            size="lg"
                            no-caret
                            variant="link"
                            v-b-tooltip.hover
                            right
                            title="Alterar status"
                            toggle-class="text-decoration-none"
                          >
                            <template #button-content>
                              <i class="mdi mdi-autorenew mdi-18px" style="color: black"/>
                            </template>
                            <div v-for="(status, index) in item?.agendamento_status" :key="index">
                              <b-dropdown-item @click="() => alterarStatus(item, status)">
                                <strong :style="{ color: status?.cor }">
                                  {{ status?.value }}
                                </strong>
                              </b-dropdown-item>
                            </div>
                          </b-dropdown>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <div class="text-center mt-3">
                      <img
                        :alt="$t('No results')"
                        src="/img/icons/robot.svg"
                        style="max-height: 200px"
                      />
                      <h3 class="bold">
                        {{ $t("No records found") }}
                      </h3>
                    </div>
                  </template>
                </tbody>
              </table>
            </section>

            <div class="d-flex justify-content-end">
              <b-button
                :title="$t('Visualizar e Imprimir')"
                type="button"
                class="m-0"
                style="padding: 7px 15px"
                v-b-tooltip.hover
                variant="primary"
                v-if="agendamentosStore.state.agendaAtiva?.agenda?.length > 0 || agendamentosStore.state.agendaAtiva?.periodo"
                @click="$bvModal.show('agenda-ativa-tecnico-impressao-modal')"
              >
                <i class="fas fa-light fa-print"></i>
              </b-button>
            </div>
          </div>
        </div>
      </section>
    </section>
  </main>
</template>

<script>
import AgendaAtivaCompromissoModal from "./components/AgendaAtivaCompromissoModal.vue";
import AtendimentoImpressaoModal from "../agendamentos/components/AtendimentoImpressaoModal.vue";
import AgendaTecnicoImpressaoModal from "../agendamentos/components/AgendaTecnicoImpressaoModal.vue";
import AtendimentoModal from "../agendamentos/components/AtendimentoModal.vue";

export default {
  name: "AgendaAtiva",
  components: {
    AtendimentoModal,
    AgendaTecnicoImpressaoModal,
    AtendimentoImpressaoModal,
    AgendaAtivaCompromissoModal
  },
  inject: [
    "agendaAtivaStore",
    "agendamentosStore"
  ],
  props: ["tab"],
  data() {
    return {
      show_name_agenda: {},
      agenda: {
        tecnico_id: null,
        data_agendamento: moment().format("YYYY-MM-DD"),
      },
      dataFormatadaAgenda: null,
      visualizacao_agenda: true,
      options_radio: [
        { id: true, value: "Minha agenda" },
        { id: false, value: "Agenda de um Técnico da Unidade" },
      ],
      isTecnico: this.$store.state.user?.role_details?.name?.toLowerCase()?.includes("técnico"),
      tecnicoLogado: this.$store.state.user.tecnico,
      atendimento: {
        id: null,
        pessoas: null,
        local: null,
        tipos: null,
        tipo_servico_id: null,
        outra_unidade: null,
        descricao_sumaria: null,
        familia_id: null,
        data_cadastro: null,
        necessita_interprete_libras: false,
        forma_acesso_id: null
      },
      agendamento_cadastro: {
        id: null,
        dia: null,
        hora_inicio: null,
        repetivel: false,
        hora_fim: null,
        descricao: null,
        tecnico_id: null,
        data: null,
        dia_fim: null,
        unidade_id: null,
        tipo_compromisso_id: null,
        has_data_fim: false,
        motivo_id: null,
      }
    }
  },
  mounted() {
    this.getDataAgendamento(this.agenda.data_agendamento);
    this.agendaAtivaStore.dispatch("getTecnicos");

    this.getAgenda(this.tecnicoLogado?.id, this.agenda.data_agendamento);
  },
  watch: {
    agenda: {
      handler(newVal) {
        const { data_agendamento, tecnico_id } = newVal;

        if (!data_agendamento) return;

        const tecnicoId = this.visualizacao_agenda
          ? this.tecnicoLogado?.id
          : tecnico_id || null;

        if (tecnicoId) this.getAgenda(tecnicoId, data_agendamento);
      },
      deep: true,
    },
    visualizacao_agenda(newVal) {
      if (newVal) {
        this.agenda.tecnico_id = null;
        this.tecnicoLogado = this.$store.state.user.tecnico;
      }
    },
    tab(newVal) {
      if (newVal === "agenda_ativa") {
        if (this.getTecnicoId()) this.getAgenda(this.getTecnicoId(), this.agenda.data_agendamento);
      }
    }
  },
  methods: {
    limparEstado(obj, camposPreservados = []) {
      for (const key in obj) {
        if (camposPreservados.includes(key)) {
          continue;
        }

        if (typeof obj[key] === "object" && obj[key] !== null) {
          this.limparEstado(obj[key], camposPreservados);
        } else if (typeof obj[key] === "boolean") {
          obj[key] = false;
        } else {
          obj[key] = null;
        }
      }
    },

    toggleNameAgenda(id, state) {
      this.$set(this.show_name_agenda, id, state);
    },

    getTecnicoId() {
      if (this.visualizacao_agenda) return this.tecnicoLogado?.id
      else return this.agenda.tecnico_id || null;
    },

    getDataAgendamento(data) {
      this.getExpediente(this.tecnicoLogado?.unidade_id, data);

      this.dataFormatadaAgenda = moment(data).format("dddd, D [de] MMMM [de] YYYY");

      this.dataFormatadaAgenda = this.dataFormatadaAgenda.charAt(0).toUpperCase() + this.dataFormatadaAgenda.slice(1);
    },

    getAgenda(tecnico_id, data_agendamento) {
      this.agendamentosStore.dispatch("getAgenda", {
        tecnico_id: tecnico_id,
        dia: data_agendamento,
        loading_mutations: "SET_LOADING_AGENDA_ATIVA",
        model_mutations: "SET_AGENDA_ATIVA"
      });
    },

    getExpediente(unidade_id, data_agendamento) {
      this.agendamentosStore.dispatch("getExpediente", {
        unidade_id: unidade_id,
        dia: data_agendamento,
        model_mutations: "SET_EXPEDIENTE_AGENDA_ATIVA"
      });
    },

    setTecnico(tecnicoId) {
      if (tecnicoId) {
        const tecnico = this.agendaAtivaStore.state.tecnicos.find(
          (e) => e.id === tecnicoId
        );

        this.tecnicoLogado = {
          ...this.tecnicoLogado,
          id: tecnico?.id,
          profissao: tecnico?.profissao,
          nome: tecnico?.value
        }
      }
    },

    impressaoAgendamento(item) {
      this.agendamentosStore.dispatch("getAgendamento", {
        agenda_atendimento_id: item.agenda_atendimento?.id,
      }).then(res => {
        if (res?.data?.data) {
          this.$bvModal.show("atendimento-agenda-ativa-impressao-modal");
        }
      })
    },

    cancelar(item) {
      swal
        .fire({
          title: "Confirmação de cancelamento",
          text: "Caso este seja o único agendamento, o atendimento será finalizado e o horário ficará disponível para novos agendamentos na agenda. Caso contrário, apenas o horário será liberado. Confirma o cancelamento?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.agendamentosStore.dispatch("cancelar", {
              agendamento_id: item.agenda_atendimento.id,
            }).then(res => {
              if (res.status === 204) {
                if (this.getTecnicoId()) this.getAgenda(this.getTecnicoId(), this.agenda.data_agendamento);

                this.$snack.success({
                  button: false,
                  text: "Agendamento cancelado com sucesso!",
                });
              }
            })
          }
        });
    },

    getAtendimento(item) {
      if (item?.atendimento?.id) {
        this.agendamentosStore.dispatch("getAtendimento", {
          atendimento_id: item?.atendimento?.id,
        }).then(res => {
          if (res?.data?.data) {
            this.atendimento = res.data.data;

            this.atendimento.pessoas = item?.atendimento?.usuarios?.map(e => e.id).join(", ");

            this.atendimento.familia_id = item?.atendimento?.familia_id;

            if (this.atendimento.local) {
              const local_atendimento = this.agendamentosStore?.state?.locais_atendimento.find((e) => e.id === this.atendimento.local);

              this.agendamentosStore?.commit("SET_LOCAL_ATENDIMENTO", local_atendimento);
            }

            this.$bvModal.show("atendimento-edicao-modal");
          }
        })
      }
    },

    async putAtendimento() {
      if (!this.agendamentosStore.state?.local_atendimento?.permite_outra_unidade)
        this.atendimento.outra_unidade = null;

      let ladda = Ladda.create(document.querySelector(".btn-submit-atendimento-edicao"));
      ladda.start();

      await this.agendamentosStore.dispatch("putAtendimento", {
        atendimento: this.atendimento,
        atendimento_id: this.atendimento?.id,
        model_mutations: "SET_ATENDIMENTO_AGENDA_ATIVA"
      }).then(r => {
        if (r?.data?.data) {
          if (this.getTecnicoId()) this.getAgenda(this.getTecnicoId(), this.agenda.data_agendamento);

          this.$snack.success({
            button: false,
            text: "Atendimento atualizado com sucesso!",
          });

          this.$bvModal.hide("atendimento-edicao-modal");
        }
      })
      ladda.stop();
    },

    async saveAgendamento() {
      this.agendamento_cadastro.unidade_id = this.tecnicoLogado?.unidade_id;
      this.agendamento_cadastro.tecnico_id = this.getTecnicoId();

      if (this.agendaAtivaStore.state.tipo_compromisso?.slug?.includes("afastamento")
      || this.agendaAtivaStore.state.tipo_compromisso?.slug?.includes("periodo-de-ferias")
      || this.agendaAtivaStore.state.tipo_compromisso?.slug?.includes("indisponibilizar-todos-os-horarios")) {
        delete this.agendamento_cadastro.hora_inicio;
        delete this.agendamento_cadastro.hora_fim;
        this.agendamento_cadastro.dia = this.agendamento_cadastro.data?.start || this.agenda.data_agendamento;
        this.agendamento_cadastro.dia_fim = this.agendamento_cadastro.data?.end || null;
        this.agendamento_cadastro.repetivel = false;
      } else {
        if (!this.agendamento_cadastro.id) {
          this.agendamento_cadastro.dia = this.agenda.data_agendamento;

          if (this.agendamento_cadastro.repetivel) {
            this.agendamento_cadastro.dia = this.agendamento_cadastro.data?.start || this.agenda.data_agendamento;
            this.agendamento_cadastro.dia_fim = this.agendamento_cadastro.data?.end || null;
          }
        }
      }

      if (!this.agendaAtivaStore.state.tipo_compromisso?.slug?.includes("indisponibilizar-todos-os-horarios") && !this.agendamento_cadastro.id)
        this.agendamento_cadastro.descricao = null;

      let ladda = Ladda.create(document.querySelector(".btn-submit-agendamento-cadastro-agenda-ativa"));
      ladda.start();

      if (this.agendamento_cadastro.id) {
        if (this.agendamento_cadastro.has_data_fim) {
          this.agendamento_cadastro.dia = this.agendamento_cadastro.data?.start;
          this.agendamento_cadastro.dia_fim = this.agendamento_cadastro.data?.end;
          delete this.agendamento_cadastro.hora_inicio;
          delete this.agendamento_cadastro.hora_fim;
        } else {
          delete this.agendamento_cadastro.data;
          delete this.agendamento_cadastro.dia_fim;
        }

        delete this.agendamento_cadastro.tipo_compromisso_id;
        delete this.agendamento_cadastro.repetivel;

        await this.agendaAtivaStore.dispatch("putAgendamento", {
          agendamento_id: this.agendamento_cadastro.id,
          agendamento: this.agendamento_cadastro
        }).then(r => {
          if (r.status === 204) {
            if (this.getTecnicoId()) this.getAgenda(this.getTecnicoId(), this.agenda.data_agendamento);

            this.$snack.success({
              button: false,
              text: "Evento/compromisso reagendado com sucesso!",
            });

            this.$bvModal.hide("agenda-ativa-compromisso-modal");
          }
        })
      } else {
        delete this.agendamento_cadastro.motivo_id;

        await this.agendamentosStore.dispatch("saveAgendamento", {
          item: this.agendamento_cadastro
        }).then(r => {
          if (r?.data?.data) {
            if (this.getTecnicoId()) this.getAgenda(this.getTecnicoId(), this.agenda.data_agendamento);

            this.$snack.success({
              button: false,
              text: "Evento/compromisso cadastrado com sucesso!",
            });

            this.$bvModal.hide("agenda-ativa-compromisso-modal");
          }
        })
      }
      ladda.stop();
    },

    adicionarNovoEvento() {
      this.limparEstado(this.agendamento_cadastro);
      this.agendaAtivaStore.commit("SET_TIPO_COMPROMISSO", null);
      this.$bvModal.show('agenda-ativa-compromisso-modal')
    },

    async getAgendamentoById(item) {
      this.agendaAtivaStore.commit("SET_TIPO_COMPROMISSO", null);
      this.limparEstado(this.agendamento_cadastro);
      await this.agendaAtivaStore.dispatch("getAgendamentoById", {
        agendamento_id: item.id,
      }).then(r => {
        if (r.data.data) {
          this.agendamento_cadastro = {
            ...r.data.data,
            descricao: null,
            hora_fim: `${r.data.data.dia} ${r.data.data.hora_fim}:00`,
            hora_inicio: `${r.data.data.dia} ${r.data.data.hora_inicio}:00`,
          }

          if (r.data.data.dia_fim) {
            this.agendamento_cadastro = {
              ...r.data.data,
              data: {
                start: r.data.data.dia,
                end: r.data.data.dia_fim
              },
              has_data_fim: true,
              descricao: null,
              hora_fim: `${r.data.data.dia} ${r.data.data.hora_fim}:00`,
              hora_inicio: `${r.data.data.dia} ${r.data.data.hora_inicio}:00`,
            }
          }

          this.$bvModal.show('agenda-ativa-compromisso-modal');
        }
      });
    },

    async alterarStatus(item, status) {
      await this.agendaAtivaStore.dispatch("putAgendamento", {
        agendamento_id: item?.id,
        agendamento: {
          status_id: status?.id
        },
      }).then(r => {
        if (r.status === 204) {
          if (this.getTecnicoId()) this.getAgenda(this.getTecnicoId(), this.agenda.data_agendamento);

          this.$snack.success({
            button: false,
            text: "Status alterado com sucesso!",
          });
        }
      });
    },

    deleteAgendamento(item) {
      swal
        .fire({
          title: "Confirmação de exclusão",
          text: "Se você excluir esta atividade, o horário correspondente ficará disponível para outros agendamentos. Deseja prosseguir com a exclusão?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.agendaAtivaStore.dispatch("deleteAgendamento", {
              agendamento_id: item.id,
            }).then(res => {
              if (res.status === 204) {
                if (this.getTecnicoId()) this.getAgenda(this.getTecnicoId(), this.agenda.data_agendamento);

                this.$snack.success({
                  button: false,
                  text: "Atividade excluída com sucesso!",
                });
              }
            })
          }
        });
    },

    getTextStatusStyle(item) {
      return {
        color: (item?.atendimento && item?.status?.value === "REAGENDADO") ? "#0d6efd" : ""
      }
    }
  }
}
</script>
